export default {
    methods: {
        towersGetMultiplierRow(risk) {
            return risk === 'easy' ? 1.395 : risk === 'medium' ? 1.86 : 2.79;
        }
    }
};